import { useCallback } from 'react';
import { showToast } from '../../utils/toast';
import { listingsService } from '../../api';

// Mirrors mobile Step 3 (sell.tsx Photos). Uploads up to 15 images via the
// dedicated photos endpoint — there is no upsertStep call for this step.
export const usePhotosHandler = () => {
  const handleNext = useCallback(
    async (formData: Record<string, any>): Promise<boolean> => {
      const params = new URLSearchParams(window.location.search);
      const id = params.get('id') || undefined;

      if (!id) {
        showToast.error('Save Step 1 first');
        return false;
      }

      const images = Array.isArray(formData.images) ? formData.images : [];
      const localFiles: File[] = images
        .map((item: any) => {
          if (item instanceof File) return item;
          if (item && item.originFileObj instanceof File) return item.originFileObj as File;
          return null;
        })
        .filter(Boolean) as File[];

      if (localFiles.length === 0) {
        // No new photos — proceed (existing photos already on the listing).
        return true;
      }

      try {
        await listingsService.uploadPhotos(id, localFiles);
        showToast.success('Photos uploaded');
        return true;
      } catch (err) {
        console.error('[LISTING][STEP 3] photo upload failed', err);
        showToast.error('Failed to upload photos');
        return false;
      }
    },
    []
  );

  const handleBack = useCallback(() => true, []);

  return { handleNext, handleBack };
};
